import { request } from '../../../gateways/api'
import type { HoofdleidingProject } from '../types/HoofdleidingProject'

export { fetchProject }

const fetchProject = async ({
  id,
}: {
  id: string
}): Promise<HoofdleidingProject> => {
  const result = await request({
    url: `/rest/project/${id}`,
    method: 'GET',
  })

  return result
}
